import { FunctionComponent } from 'react';
import { siderHeaderTitleId } from 'packages/at-shell/components/app-shell/app-layout-constants';

export const AT_SHELL_LIGHT_GRAY_BORDER_COLOR = '#eaeaea';

export const ThemeStyles: FunctionComponent<
  React.PropsWithChildren<{
    colorTheme?: 'light' | 'dark';
  }>
> = ({ colorTheme }) => {
  const lightStyles = `
    .ant-layout-header {}
    #${siderHeaderTitleId} {
      color: #fff;
    }
    .ant-layout-sider, .ant-layout-sider-dark, .ant-layout-sider.ant-layout-sider-dark {
      background: #ffffff;
      border-right: 1px solid ${AT_SHELL_LIGHT_GRAY_BORDER_COLOR};
    }
    .sider {
      background: #ffffff;
      border-left: 1px solid ${AT_SHELL_LIGHT_GRAY_BORDER_COLOR};
    }
    .sider .header {
      width: calc(100% + 1px);
      transform: translateX(-1px);
      background: #001529f6;
      border-left: 1px solid #ffffff11;
      border-bottom: 1px solid #001529;
    }
    .sider *::-webkit-scrollbar {
      width: 6px;
      height: 8px;
    }
    .sider *::-webkit-scrollbar-thumb {
      background: #aaa;
      border-radius: 3px;
    }
    .sider *::-webkit-scrollbar-track {
      background: #fff;
      border-radius: 3px;
    }
    .footer::-webkit-scrollbar {
      height: 6px;
    }
    .footer::-webkit-scrollbar-thumb {
      background: #aaa;
      border-radius: 3px;
    }
    .footer::-webkit-scrollbar-track {
      background: #fff;
      border-radius: 3px;
    }
    #primary-view::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    #primary-view::-webkit-scrollbar-thumb {
      background: #aaa;
      border-radius: 3px;
    }
    #primary-view::-webkit-scrollbar-track {
      background: #fff;
      border-radius: 3px;
    }
    .sider .footer {
      border-top: 1px solid ${AT_SHELL_LIGHT_GRAY_BORDER_COLOR};
      background: white;
    }
      `;
  const darkStyles = `
    .ant-layout-header {
      background: #000000;
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    }
    #${siderHeaderTitleId} {
      color: #fff;
    }
    .ant-layout-sider, .ant-layout-sider-dark, .ant-layout-sider.ant-layout-sider-dark {
      background: #000000;
      border-right: 1px solid rgba(255, 255, 255, 0.5);
    }
    .sider {
      border-left: 1px solid rgba(255, 255, 255, 0.5);
    }
    .sider .header {
      width: calc(100% + 1px);
      transform: translateX(-1px);
      border-bottom: 1px solid rgba(255, 255, 255, 0.5);
    }
    .sider *::-webkit-scrollbar {
      width: 6px;
    }
    .sider *::-webkit-scrollbar-thumb {
      background: #666;
      border-radius: 3px;
    }
    .sider *::-webkit-scrollbar-track {
      background: #000;
      border-radius: 3px;
    }
    .footer::-webkit-scrollbar {
      height: 6px;
    }
    .footer::-webkit-scrollbar-thumb {
      background: #666;
      border-radius: 3px;
    }
    .footer::-webkit-scrollbar-track {
      background: #000;
      border-radius: 3px;
    }
    #primary-view::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    #primary-view::-webkit-scrollbar-thumb {
      background: #666;
      border-radius: 3px;
    }
    #primary-view::-webkit-scrollbar-track {
      background: #000;
      border-radius: 3px;
    }
    .sider .footer {
      border-top: 1px solid rgba(255, 255, 255, 0.5);
      background: black;
    }
      `;
  return (
    <>
      {colorTheme === 'dark' ? (
        <style>{darkStyles}</style>
      ) : (
        <style>{lightStyles}</style>
      )}
    </>
  );
};
